import React from 'react';

import NavBar from '../NavBar/index';
import ServicesCarousel from '../ServicesCarousel/index';

import './Services.css';

const Services = () => {

  console.log('s')

  return (
    <div className="services">
      <NavBar />
      <div className="founders-container">
        <h1 className="title">SERVICIOS</h1>
      </div>
      <ServicesCarousel />
    </div>
  );
};

export default Services;
